export default __webpack_public_path__ + "static/media/mercado-libre2.60e4b141.webp";